/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  AuthSuccess(state, response) {
    state.token = response.token
    state.user_type = response.user_type
    state.expiration_time = response.expiration_time
  },
  AuthLogout(state) {
    state.user_type = ''
    state.user_info = ''
    state.token = ''
    state.expiration_time = ''
  }
}
